import { datadogLogs } from '@datadog/browser-logs';
import { Component, ReactNode } from 'react';

import ErrorHandler from '@wetransfer/transfer/modules/error-handler/error-handler';

interface Props {
  children: ReactNode;
  componentName?: string;
  logMessage?: string;
}

export class ErrorBoundary extends Component<Props> {
  componentDidCatch(error: Error, info: any) {
    const message =
      this.props.logMessage ||
      'EMERGENCY: There was a terminal client-side error';

    ErrorHandler.track(message, {
      error,
      info,
      component: this.props.componentName,
    });

    datadogLogs.logger.error(message, {
      error,
      stack: info.componentStack,
      component: this.props.componentName,
    });
  }

  render() {
    return this.props.children;
  }
}
